import cookieHelper from "@irati/utils/cookies"
import EnvVariables from "./interface/env"

function getCookie(COOKIE_NAME: string) {
  try {
    const version = cookieHelper.getItem(COOKIE_NAME) || ""
    return version
  } catch (e) {
    return ""
  }
}

function getMeta(name: string): string {
  try {
    const value = document.querySelector(`meta[name="${name}"]`)?.getAttribute("content") || ""
    return value.startsWith("{{") ? "" : value
  } catch {
    return ""
  }
}

const env = ENVIRONMENT_NAME || getMeta("env")
const graphql = getCookie("PBFEGraphUrl") || GRAPH_QL || getMeta("graph_ql")
const apigw = API_GW || getMeta("api_gw")
const islocal = IS_LOCAL
const getLocal = "localhost"
const bundleref = BUNDLE_REF
const public_url = PUBLIC_URL

export default {
  ENVIRONMENT_NAME: env,
  GRAPH_QL: graphql,
  API_GW: apigw,
  IS_LOCAL: islocal,
  GET_LOCAL: getLocal,
  BUNDLE_REF: bundleref,
  PUBLIC_URL: public_url
} as EnvVariables
